import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import './AdminLogin.css';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // Admin credentials from environment variables
  const ADMIN_CREDENTIALS = [
    {
      username: process.env.REACT_APP_ADMIN_1_USERNAME,
      password: process.env.REACT_APP_ADMIN_1_PASSWORD
    },
    {
      username: process.env.REACT_APP_ADMIN_2_USERNAME,
      password: process.env.REACT_APP_ADMIN_2_PASSWORD
    },
    {
      username: process.env.REACT_APP_ADMIN_3_USERNAME,
      password: process.env.REACT_APP_ADMIN_3_PASSWORD
    }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Check credentials locally from environment variables
      const admin = ADMIN_CREDENTIALS.find(
        cred => cred.username === username && cred.password === password
      );

      if (!admin) {
        setError('Invalid admin credentials');
        setLoading(false);
        return;
      }

      // Generate a simple token (in production, should be from backend)
      const token = btoa(`${username}:${Date.now()}`);
      
      // Store token in localStorage
      localStorage.setItem('adminToken', token);
      localStorage.setItem('adminUsername', admin.username);
      setUsername('');
      setPassword('');
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Authentication error. Please try again.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <h1>Admin Login</h1>
            <p>Access the conference management dashboard</p>
          </div>

          {error && (
            <div className="admin-login-error">
              <FaEyeSlash className="error-icon" />
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="admin-login-form">
            <div className="admin-form-group">
              <label htmlFor="username" className="admin-form-label">
                <FaUser className="form-icon" /> Username
              </label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter admin username"
                className="admin-form-input"
                required
              />
            </div>

            <div className="admin-form-group">
              <label htmlFor="password" className="admin-form-label">
                <FaLock className="form-icon" /> Password
              </label>
              <div className="admin-password-input-group">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter admin password"
                  className="admin-form-input"
                  required
                />
                <button
                  type="button"
                  className="admin-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="admin-login-btn"
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
